import axios from "axios";
import { resolveHostContext } from "../shell/useHostContext";

/**
 * API Configuration
 * Dinámico por entorno: usa VITE_API_URL en producción, localhost en desarrollo
 */

// Detectar entorno y usar API URL correcta
const isLocal = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1' ||
   window.location.hostname.includes('local'));

const defaultUrl = isLocal
  ? 'http://127.0.0.1:8000/api'
  : (window.location.origin + '/api'); 

const API_BASE = process.env.REACT_APP_API_URL ||
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_URL) ||
  defaultUrl;

console.log('🔧 [v2.3] API Base URL:', API_BASE);
// ... existing log logic ...
console.log('🔍 Env Debug:', {
  REACT_APP: process.env.REACT_APP_API_URL ? 'Set' : 'Unset',
  VITE: (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_URL) ? 'Set' : 'Unset',
  isProduction: !isLocal,
  timestamp: new Date().toISOString()
});

// Export both default and named exports for compatibility
export default API_BASE;
export const API_URL = API_BASE;

// Local Printer Bridge URL (Silent printing on Windows)
export const PRINTER_SERVICE_URL = 'http://localhost:8001';

// Config para requests con credentials
export const apiConfig = {
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
};
